import { Model } from "flexlayout-react";
import { OaRChart } from "../charts/OaRChart";
import { VaRChart } from "../charts/VaRChart";
import { Legend } from "../charts/Legend";
import { RiskModelLegend } from "../charts/RiskModelLegend";
import { Dummy } from "../../oarvar/charts/Dummy";
import { Header } from "../../../components/Header";
import { AverageTableView } from "../tableview/AverageTableView";
import { FilterTitle, NoTitle } from "../../vectorset2/layout/VectorSet2Titles";

import { FilterList } from "../filterlist/FilterList";

export const factory = (node) => {
  var component = node.getComponent();
  switch (component) {
    case "VaRChart":
      return <VaRChart />;
    case "OaRChart":
      return <OaRChart />;
    case "AverageTableView":
      return <AverageTableView />;
    case "Legend":
      return <Legend />;
    case "Header":
      return (
        <Header
          title="Consider how the Value at Risk (VaR) and Opportunity at Risk (OaR) of the ticker you are interested in compares to that of other tickers with similar V-Scores to better understand the potential for upside and downside volatility. You can select the probability of VaR and OaR being exceeded (95% or 99%), the forward time horizon (1 day thru 1 year) and the risk model that you prefer (Vector or Sigma) or you can select them all and consider the average and how each ticker compares to the average.  You can also use the chart to consider how the V-Score and VaR and OaR levels have varied for a given ticker or set of tickers over time."
          label="oarvar"
        >
          <div>
            Opportunity at Risk (OaR) and Value at Risk (VaR) vs V-Score
          </div>
        </Header>
      );
    case "RiskModelLegend":
      return <RiskModelLegend />;
    case "ModelDate":
      return <FilterList field={"ModelDate"} search={false} />;
    case "RiskModel":
      return <FilterList field={"RiskModel"} search={false} />;
    case "Ticker":
      return <FilterList field={"Ticker"} search={false} />;
    case " Pctile ":
      return <FilterList field={" Pctile "} search={false} />;
    case "Horizon":
      return <FilterList field={"Horizon"} search={false} />;
    default:
      return <Dummy />;
  }
};

export const onRenderTabSet = (tabSetNode, refs) => {
  const typeNode = tabSetNode.getType();
  if (typeNode === "tabset") {
    const children = tabSetNode.getChildren();
    children.forEach((child) => {
      const c = child;
      const comp = c.getComponent();
      const rect = c.getRect();
      if (comp) {
        refs.componentSize.current[comp] = {
          width: rect.width,
          height: rect.height,
        };
      }
    });
  }
};
const getParentTabsets = (model) => {
  const tree = {};
  const walk = (obj) => {
    if (obj.children) {
      const parent = obj.id;
      tree[parent] = [];
      obj.children.forEach((item) => {
        tree[parent].push(item.id);
        walk(item);
      });
    }
  };
  walk(model.layout);
  const parents = {};
  Object.entries(tree).forEach((item) => {
    item[1].forEach((child) => {
      parents[child] = item[0];
    });
  });
  return parents;
};

const modifyModel = (model, layoutState, setLayoutState) => {
  if (layoutState.actionRef.current !== undefined) {
    let tabsetId = "";
    if (layoutState.actionRef.current.isTab) {
      const parent = getParentTabsets(model);
      tabsetId = parent[layoutState.actionRef.current.tabid];
    } else {
      tabsetId = layoutState.actionRef.current.tabid;
    }
    let update = (obj) => {
      if (obj.id === tabsetId) {
        //update
        Object.entries(layoutState.actionRef.current.attributes).forEach(
          (item) => {
            obj[item[0]] = item[1];
          }
        );
      } else if (obj.children) {
        obj.children.forEach((item) => update(item));
      }
    };
    update(model.layout);

    const newState = {
      ...layoutState,
      model: Model.fromJson(model),
    };

    setLayoutState(newState);
    return model;
  } else {
    return model;
  }
};

export const onAction = (action, layoutState) => {
  const nodeID = action.data.fromNode;
  if (nodeID) {
    layoutState.actions.prepareAction(nodeID);
  }
  return action;
};

export const layoutModelChange = (
  model,
  layoutState,
  setLayoutState,
  grefs
) => {
  //  console.log(JSON.stringify(model.toJson()));
  grefs.layout.current = JSON.stringify(
    modifyModel(model.toJson(), layoutState, setLayoutState)
  );
};
export const onRenderTab = (node, renderState, componentSize) => {
  var component = node.getComponent();
  switch (component) {
    case "ModelDate":
      renderState.content = (
        <FilterTitle
          componentSize={componentSize}
          title={"Model Date"}
          name={component}
        />
      );
      break;
    case "Legend":
      renderState.content = (
        <FilterTitle
          componentSize={componentSize}
          title={"Ticker"}
          name={component}
        />
      );
      break;
    case "RiskModelLegend":
      renderState.content = (
        <FilterTitle
          componentSize={componentSize}
          title={"Risk Model"}
          name={component}
        />
      );
      break;
    case "Horizon":
      renderState.content = (
        <FilterTitle
          componentSize={componentSize}
          title={"Horizon"}
          name={component}
        />
      );
      break;
    case "RiskModel":
      renderState.content = (
        <FilterTitle
          componentSize={componentSize}
          title={"Risk Model"}
          name={component}
        />
      );
      break;
    case " Pctile ":
      renderState.content = (
        <FilterTitle
          componentSize={componentSize}
          title={"Pctile"}
          name={component}
        />
      );
      break;
    case "Ticker":
      renderState.content = (
        <FilterTitle
          componentSize={componentSize}
          title={"Ticker"}
          name={component}
        />
      );
      break;
    case "Dummy":
      renderState.content = (
        <NoTitle componentSize={componentSize} name={"Dummy"} />
      );
      break;
    case "Header":
      renderState.content = (
        <NoTitle componentSize={componentSize} name={"Header"} />
      );
      break;
    case "VaRChart":
      renderState.content = (
        <NoTitle componentSize={componentSize} name={"VaRChart"} />
      );
      break;
    case "OaRChart":
      renderState.content = (
        <NoTitle componentSize={componentSize} name={"OaRChart"} />
      );
      break;

    default:
    //do nothing
  }
};
